module.exports = __webpack_public_path__ + "static/media/admin-grey.f6511d65.svg";